import React, { ComponentProps } from "react";
import { Avatar, AvatarFallbackText, AvatarImage } from "../../ui/avatar";
import { HStack } from "../../ui/hstack";
import { Text } from "../../ui/text";
import { UserFragmentFragment } from "@repo/graphql/documents/user/fragment.generated";

type Props = {
  user: UserFragmentFragment;
  avatarProps?: ComponentProps<typeof Avatar>;
  textProps?: ComponentProps<typeof Text>;
  hstackProps?: ComponentProps<typeof HStack>;
  children?: React.ReactNode;
};

const UserAvatarName = React.memo((props: Props) => {
  const { avatarProps, textProps, hstackProps = { space: "md" } } = props;
  const user = props.user;
  const userProfilePicture = user.profilePicture;
  return (
    <HStack className="items-center" {...hstackProps}>
      <Avatar {...avatarProps}>
        <AvatarFallbackText>{user.fullName}</AvatarFallbackText>
        <AvatarImage source={{ uri: userProfilePicture?.url }} />
      </Avatar>
      <Text numberOfLines={1} {...textProps}>
        {user.fullName || user.email}
      </Text>
      {props.children}
    </HStack>
  );
});

UserAvatarName.displayName = "UserAvatarName";

export default UserAvatarName;
